// src/components/layout/PageLayout.jsx
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Menu } from 'lucide-react';

const PageLayout = ({ 
  children, 
  title, 
  subtitle,
  showBackButton = true,
  rightAction,
  headerClassName = '',
  containerClassName = ''
}) => {
  const navigate = useNavigate();
  
  const handleBack = () => {
    navigate(-1);
  };
  
  return (
    <div className="min-h-screen bg-[#f5f5f5]">
      {/* Header */}
      <header className={`bg-white shadow-sm sticky top-0 z-10 ${headerClassName}`}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            <div className="flex items-center">
              {showBackButton && (
                <button
                  onClick={handleBack}
                  className="p-2 rounded-lg hover:bg-gray-100 mr-2 transition-colors"
                  aria-label="Go back"
                >
                  <ArrowLeft className="w-5 h-5 text-gray-700" />
                </button>
              )}
              <div>
                <h1 className="text-xl font-bold text-[#0f0e0e]">{title}</h1>
                {subtitle && (
                  <p className="text-sm text-gray-600">{subtitle}</p>
                )}
              </div>
            </div>
            
            {rightAction && (
              <div className="flex items-center">
                {rightAction}
              </div>
            )}
          </div>
        </div>
      </header>
      
      {/* Main Content */}
      <main className={`max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 ${containerClassName}`}>
        {children}
      </main>
    </div>
  );
};

export default PageLayout;